import React, { useState, useEffect, memo } from "react";
import {Grid, Box, Typography, IconButton, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import PSIcon from "../../components/PSIcon";
import { getText } from "../../libs/utils";
import CustomFilter from "./CustomFilter";
import {CloseIcon} from '../../assets/images/icons';

const CryptoBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: 13,
  minHeight: 43.5,
  cursor: "pointer",
  borderRadius: 10,
  margin: "4px 4px 4px",
  padding: '4px 5px 4px 0',
  "&:hover": {
    background: theme.palette.primary.greyBg,
  },
  "&.selected": {
    background: '#FFE7E7',
  },
  ".cost": {
    display: "block",
    fontSize: 12,
    color: theme.palette.primary.grey,
    padding: '5px 0 0'
  },
}));

const PaySystemList = ({title, list, onClose, activeSystem, setSystem, showFilter = true, grid = 5, setCurrency = () => {}}) => {

  const filterSystems = new Map([
    ['ALL', getText('psFilterAllPS')],
    [1, getText('psFilterCrypto')],
    [0, getText('psFilterBank')],
    [2, getText('psFilterPS')],
    [3, getText('psFilterCheck')],
  ]);

  const filterCur = new Map([
    ["ALL", getText('psFilterAllCurr')],
    ["RUB", "RUB"],
    ["USD", "USD"],
    ["EUR", "EUR"],
  ]);

  const filterNet = new Map([
    ["ALL", getText('psFilterAllCurr')],
    ["BEP20", "BEP20"],
    ["ERC20", "ERC20"],
    ["TRC20", "TRC20"],
  ]);

  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const [filteredList, setFilteredList] = useState(list);
  const [curFilterList, setCurFilterList] = useState(new Map([...filterCur, ...filterNet]));
  const [activeSysFilter, setActiveSysFilter] = useState(null);
  const [activeCurFilter, setActiveCurFilter] = useState(null);

  const handleClick = (system) => {
    // const systemData = system;
    // systemData.currencies.sort((a, b) => a.name.localeCompare(b.name));
    setSystem(system);
    setCurrency(system["currencies"][0]);
    onClose();
  };

  useEffect(() => {
    if (activeSysFilter !== null) {
      if (activeSysFilter == 'ALL') {
        setFilteredList(list);
        setCurFilterList(new Map([...filterCur, ...filterNet]));
      } else {
        setFilteredList(list.filter((item) => item.type == activeSysFilter));
        activeSysFilter == 1
          ? setCurFilterList(new Map([...filterNet])) // currency filter for crypto 
          : setCurFilterList(new Map([...filterCur]));
      }

      !['ALL', null].includes(activeCurFilter) && setActiveCurFilter('ALL');
    }
  }, [activeSysFilter]);

  useEffect(() => {
    if(activeCurFilter){
      // get clean system list filtered by type
      const cleanList = ['ALL', null].includes(activeSysFilter) ? list : list.filter((item) => item.type == activeSysFilter);

      ['ALL', null].includes(activeCurFilter)
        ? setFilteredList(cleanList)
        : setFilteredList(cleanList.reduce((filtered, item) => {
          Object.keys(item.currencies).map((key) => {
            item.currencies[key].name == activeCurFilter && filtered.push(item);
          })
          return filtered;
        }, []));
    }
  }, [activeCurFilter]);
 
  const showDivider = (type, prevType) => {
    if(prevType !== undefined && type != prevType){
      return <Grid item xs={12} style={{margin: "15px 0", borderBottom: "1px solid #EAEAEA"}}></Grid>
    }
  }

  let sortedSystems = [...filteredList];
  sortedSystems.sort((x, y) => {
    if(x.type > y.type) return 1;
    if(x.type < y.type) return -1;
    return 0;
  })

  return (
    <Box>
      <Box sx={{padding: '16px 24px 0'}}>
        <Grid container alignItems="center">

          {showFilter ? <>
            <Grid item md={7} sm={6} xs={12}>
              <Typography variant="h4" sx={{marginBottom: {xs: '10px', sm: '0'}}}>{title}</Typography>
            </Grid>
            <Grid item md={5} sm={6} xs={12}>
              <Box display="flex" justifyContent={isXS ? 'space-between' : 'flex-end'} alignItems="center">

                <CustomFilter
                  filterSystems={filterSystems}
                  activeFilter={activeSysFilter}
                  setActiveFilter={setActiveSysFilter}
                  defaultText={getText('psFilterAllPS')}
                />

                <CustomFilter
                  filterSystems={curFilterList}
                  activeFilter={activeCurFilter}
                  setActiveFilter={setActiveCurFilter}
                  defaultText={getText('psFilterAllCurr')}
                  styles={{width: 150, marginLeft: '8px'}}
                />

              </Box>
            </Grid>
          </>
            : <>
              <Grid item xs={12}>
                <Typography variant="h4">{title}</Typography>
              </Grid>
            </>
          }
        </Grid>
        {onClose ? (
          <CloseIcon
            onClick={onClose}
            style={{
              position: "absolute",
              right: 12,
              top: 10,
              cursor: 'pointer'
            }}
          />
        ) : null}
      </Box>

      <Box sx={{minHeight: '220px', padding: {xs: '20px 8px 5px', sm: '20px 7px'}}}>
        <Grid container columns={grid}>
          {sortedSystems.map((item, key, arr) => (
            <React.Fragment key={key}>
              {showDivider(item.type, arr[key - 1]?.type)}
              <Grid item xs={1}>
                <CryptoBox
                  className={
                    item.id == activeSystem.id ? "selected" : null
                  }
                  onClick={() => handleClick(item)}
                >
                  <PSIcon
                    name={item.className}
                    width={21}
                    height={21}
                  />
                  <Box sx={{wordBreak: 'break-word', lineHeight: '14px'}}>
                    {item.name || item.label}
                    {item.currencies[0]?.page &&
                      <span className="cost">
                        {item.currencies[0].page.rateValues.fromValue}:{item.currencies[0].page.rateValues.toValue}
                      </span>
                    }
                  </Box>
                </CryptoBox>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

// export default PaySystemList;
export default memo(PaySystemList);
